import React from "react";

// material ui
import { DashboardTwoTone } from "@material-ui/icons";

const Dashboard = () => {
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<DashboardTwoTone />
				</div>
				<h4 className="header-title">Dashboard</h4>
			</div>
			<div className="page-container">
			</div>
		</div>
	);
};

export default Dashboard;
